document.addEventListener("DOMContentLoaded", (event) => {
	const secondaryMenu = document.querySelector(".service-secondary-menu");

	if (secondaryMenu) {
		const navItems = secondaryMenu.querySelectorAll("li");

		const menuPositionSize = secondaryMenu.getBoundingClientRect().height;
		const menuPositionTop = secondaryMenu.getBoundingClientRect().bottom;

		const offsetAmount = menuPositionSize + menuPositionTop;

		secondaryMenu.addEventListener("click", (e) => {
			if (e.target.closest("li") || e.target.tagName === "LI") {
				let id;
				if (e.target.closest("li")) {
					id = e.target.closest("li").dataset.id;
				} else {
					id = e.target.dataset.id;
				}
				if (!id) return;
				const section = document.getElementById(id);
				section.scrollIntoView();
			}
		});

		const options = {
			// root: null,
			rootMargin: `-${offsetAmount}px`,
			// threshold: 0.2,
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const id = entry.target.getAttribute("id");
				const navItem = secondaryMenu.querySelector(`[data-id="${id}"]`);

				if (entry.isIntersecting) {
					navItems.forEach((item) => item.classList.remove("is-active"));
					navItem.classList.add("is-active");
				} else {
					navItem.classList.remove("is-active");
				}
			});
		}, options);

		document.querySelectorAll(".et_pb_section[id]").forEach((section) => {
			observer.observe(section);
		});
	}
});
// entry.target.classList.toggle('is-active', entry.isIntersecting)
